import {
  Arrangement,
  Product,
  SelectedProduct,
} from 'redux/PDP/arrangement/types/arrangement.types';
import { Coupon } from 'components/CYOBundle/types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface State {
  selectedProducts: SelectedProduct[];
  coupon: Coupon | null;
  freeDeliveryCoupon: Coupon | null;
  products: Product[];
  arrangements: Arrangement[];
  isStoreOrRecipientByobLock: boolean;
}

const initialState: State = {
  selectedProducts: [],
  coupon: null,
  freeDeliveryCoupon: null,
  products: [],
  arrangements: [],
  isStoreOrRecipientByobLock: false,
};

const slice = createSlice({
  name: 'BYOB',
  initialState,
  reducers: {
    addCoupon: (state, { payload }: PayloadAction<Coupon | null>) => {
      state.coupon = payload;
    },

    addFreeDeliveryCoupon: (
      state,
      { payload }: PayloadAction<Coupon | null>,
    ) => {
      state.freeDeliveryCoupon = payload;
    },

    addProduct: (
      state,
      {
        payload: { selectedProduct, product, arrangement },
      }: PayloadAction<{
        selectedProduct: SelectedProduct;
        product: Product;
        arrangement: Arrangement;
      }>,
    ) => {
      const existingProduct = state.selectedProducts.find(
        (prod) => prod.id === selectedProduct.id,
      );

      if (existingProduct) {
        existingProduct.quantity += selectedProduct.quantity || 1;
      } else {
        state.selectedProducts.push(selectedProduct);
        state.products.push(product);
        state.arrangements.push(arrangement);
      }

      return state;
    },

    deleteProduct: (
      state,
      {
        payload: { id, arrangementId },
      }: PayloadAction<{ id: number; arrangementId: number }>,
    ) => {
      const updatedselectedProducts = state.selectedProducts.filter(
        (item) => item.id !== id,
      );
      const updatedProducts = state.products.filter((item) => item.id !== id);
      const updatedArrangements = state.arrangements.filter(
        (item) => item.id !== arrangementId,
      );

      state.selectedProducts = updatedselectedProducts;
      state.products = updatedProducts;
      state.arrangements = updatedArrangements;
    },
    editQuantity: (
      state,
      { payload }: PayloadAction<{ id: number; type: string }>,
    ) => {
      state.selectedProducts = state.selectedProducts.map((product) => {
        if (product.id === payload.id) {
          return {
            ...product,
            quantity:
              payload.type === 'add'
                ? product.quantity + 1
                : product.quantity - 1,
          };
        }
        return product;
      });
    },

    validateStoreOrRecipientByobLock: (
      state,
      { payload }: PayloadAction<boolean>,
    ) => {
      state.isStoreOrRecipientByobLock = payload;
    },
  },
});

export const byobReducer = slice.reducer;
export const {
  addProduct,
  deleteProduct,
  editQuantity,
  addCoupon,
  addFreeDeliveryCoupon,
  validateStoreOrRecipientByobLock,
} = slice.actions;
